(ns ycweb.app.website.cart.addtocart
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.cart.model :as model]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]))

;; ========= Special Voucher Message Component ===========================

(rum/defc special-voucher-message-display < rum/reactive
  "Displays a special voucher message when present"
  [message]
  (when message
    [:div {:class "special-applied-message"}
     message]))

;; ========= Product Image Component ===========================

(rum/defc product-image < rum/reactive
  "Displays product image with optional ratio special sticker"
  [app-atom cart-add-response]
  (let [{:keys [items variations added]} cart-add-response
        added-item
        (when added
          (first (filter #(= (:variation_uuid %) (:variation_uuid added)) items)))

        item (or added-item (first items))
        variation (when item (get variations (:variation_uuid item)))

        special-info (:special item)
        ratio-special? (and special-info (= (:special special-info) "bundleup"))
        ratio-special-ratio-qty (when ratio-special? (:groupnumber special-info))
        ratio-special-free-qty (when ratio-special? 1)]
    [:td {:class "yc-td yc-td--product-image"}
     (when (get-in variation [:image :public_id])
       (web-common/cloudinary-lazy-image app-atom
         {:public_id (get-in variation [:image :public_id])
          :width 256
          :height 256
          :alt (:title variation)
          :html-class "yc-simple-image yc-simple-image--full cart-item__image"
          :lazyload true}))

   ;; Ratio special sticker (similar to cart-item-hero)
     (when (and ratio-special? (pos? ratio-special-ratio-qty) (pos? ratio-special-free-qty))
       [:div {:class "cart-item__graphic-sticker"}
        [:div {:class "deal-ratio-icon"}
         [:span {:class "deal-ratio-icon__int"} ratio-special-ratio-qty]
         [:span {:class "deal-ratio-icon__for"} "for"]
         [:span {:class "deal-ratio-icon__int"} (- ratio-special-ratio-qty ratio-special-free-qty)]]])]))

;; ========= Product Text Component ===========================

(rum/defc product-text < rum/reactive
  "Displays product text information with optional notes"
  [app-atom cart-add-response]
  (let [{:keys [items variations added]} cart-add-response
        added-item
        (when added
          (first (filter #(= (:variation_uuid %) (:variation_uuid added)) items)))

        item (or added-item (first items))
        variation (when item (get variations (:variation_uuid item)))

        cart-timeout? false
        cart-timeout-minutes 30]
    [:td {:class "yc-td yc-td--product-text"}
     [:div {:class "yc-td__product-name"} (:qty added) "x " [:strong (:title variation)]]

     (when (:giftcard variation)
       [:div {:class "yc-td__product-notes"}
        [:span {:class "text-status--important"}
         [:b "Please note:"] " "
         "This card will arrive packaged and blank, so that you can write your own message inside at home."]])

     ;; TODO: Need to implement timeouts on cart items?
     (when (and cart-timeout? cart-timeout-minutes)
       [:div {:class "yc-td__product-notes"}
        [:span {:class "text-status--important"}
         "Check out and " [:b (str "pay within " cart-timeout-minutes " minutes")] " to get this deal."]])]))

;; ========= Cart Item Table Component ===========================

(rum/defc cart-item-table < rum/reactive
  "Displays a cart item in table format"
  [app-atom cart-add-response]
  [:table {:id "cartTable" :class "yc-table yc-table--order-view cartTable"}
   [:colgroup
    [:col {:style {:width "100px"}}]
    [:col]]
   [:tbody {:class "yc-tbody"}
    [:tr {:class "yc-tr yc-tr--faux-last-child yc-tr--muted"}
     (product-image app-atom cart-add-response)
     (product-text app-atom cart-add-response)]]])

;; ========= Registry Question Component ===========================

(defn move-to-registry
  "Move the newly added items from cart to the active registry"
  [app-atom cart-add-response]
  (let [{:keys [added]} cart-add-response
        registry-order-id (cmn/curact app-atom [:registry/order-id])
        cartitem-uuids (:cartitem_uuids added)]

    (when (and registry-order-id cartitem-uuids)
      (swap! app-atom assoc ::submitting? true)
      (toaster/open-toast app-atom :processing "Moving item to registry..." {:closetime 10000})

      ;; Use the new cart API endpoint that handles everything server-side
      (model/move-to-registry app-atom cartitem-uuids registry-order-id
        (fn [response]
          (swap! app-atom dissoc ::submitting?)
          (toaster/close-toast app-atom)
          (cond
            (not (:success response))
            (toaster/open-toast app-atom :error "Failed to move item to registry" {:show-close-button true})

            :else
            (do
              (toaster/open-toast app-atom :success "Item moved to registry successfully!" {:show-close-button true})
              (grid/close-modal app-atom))))))))

(rum/defc registry-question < rum/reactive
  "Displays the registry question when user has a registry order"
  [app-atom cart-add-response]
  (let [submitting? (cmn/curact app-atom [::submitting?])]
    [:div
     (cart-item-table app-atom
       cart-add-response)

     [:div {:class "flex-grid-group flex-grid-group--flush"}
      [:div {:class "flex-grid-block flex-grid-block--m-1-2 flex-grid-block--l-1-4 flex-grid-block--ml-right"}
       [:div {:class "flex-grid-content"}
        (buttons/button-web "Move to Registry"
          {:href "#"
           :style :dark
           :disabled submitting?
           :full true
           :class "unclip-text--t clip-text--ml unclip-text--l"
           :on-click
           #(move-to-registry app-atom cart-add-response)})]]
      [:div {:class "flex-grid-block flex-grid-block--m-1-2 flex-grid-block--l-1-4"}
       [:div {:class "flex-grid-content"}
        (buttons/button-web "Keep in Cart"
          {:href "#"
           :style :light
           :disabled submitting?
           :full true
           :class "close_btn js-mfp-close"
           :on-click
           #(grid/close-modal app-atom)})]]]]))

;; ========= Regular Cart Item Component ===========================

(rum/defc regular-cart-item < rum/reactive
  "Displays a regular cart item (non-registry)"
  [app-atom cart-add-response]
  (let [{:keys [items variations]} cart-add-response
        first-item (first items)]

    [:div
     [:h2.yc-heading.yc-heading--small.yc-heading--sentencecase
      [:b "This item has been added to your cart"]]
     (cart-item-table app-atom cart-add-response)

     [:div {:id "cart_links" :class "flex-grid-group flex-grid-group--flush"}
      [:div {:class "flex-grid-block flex-grid-block--m-1-2 flex-grid-block--ml-1-3 flex-grid-block--ml-right"}
       [:div {:class "flex-grid-content"}
        (buttons/button-web "Proceed to Checkout"
          {:href "/order.htm?action=ShowCart"
           :style :light
           :full true
           :class "unclip-text--t clip-text--ml unclip-text--l"})]]

      [:div {:class "flex-grid-block flex-grid-block--m-1-2 flex-grid-block--ml-1-3"}
       [:div {:class "flex-grid-content"}
        (if (:forregistry_uuid first-item)
          [:span "&nbsp;"]
          (buttons/button-web "Continue shopping"
            {:href "#"
             :style :dark
             :full true
             :on-click #(grid/close-modal app-atom)}))]]]]))

;; ========= Recommended Products Section ===========================

(rum/defc recommended-products-section < rum/reactive
  "Displays recommended products in a grid"
  [app-atom products]
  (when (and products (not-empty products))
    [:div  {:class "u-margin-top-24"}
     (headings/heading "Recommended Products"
       {:type :h4
        :size :tiny})
     [:div {:id "addtocart_products" :class "flex-grid-group flex-grid-group--small flex-grid-group--flush"}
      (for [item products]
        [:div {:key (:id item)
               :class "flex-grid-block flex-grid-block--small flex-grid-block--t-1-2 flex-grid-block--ml-1-3 flex-grid-block--l-1-6"}
         (cards/product-card-default app-atom
           {:ent/display-name (:title item)
            :ent/image {:doc/public-id (:image_url item)}
            :product/id (:id item)
            :product/url (:product_url item)
            :product/brand (:brand item)
            :product/name-ex-brand (:title item)
            :product/price (:price item)
            :product/special-short-desc (:special item)
            :product/in-stock "Rush"
            :product/num-reviews 0
            :product/made-in nil
            :product/new? false
            :product/colours []
            :product/features []
            :product/variations []
            :product/stats nil}
           {:small? true})])]]))

;; ========= Banner Component ===========================

(rum/defc banner-component < rum/reactive
  "Displays add to cart banner with image, text, and optional CTA"
  [app-atom banner]
  (when banner
    (let [color-class
          (when (:colour_palette_id banner)
            (str "u-bg-" (:colour_name banner)))

          text-light?
          (and (not (:text_dark banner))
            (:colour_palette_id banner))

          banner-content
          (list
            [:div {:class "atc-banner__image-wrapper"}
             (web-common/cloudinary-lazy-image app-atom
               {:public_id (:responsive_public_id banner)
                :alt (or (:image_alt banner) (:title banner))
                :html-class "yc-simple-image yc-simple-image--full cart-item__image"
                :lazyload true})]

            [:div {:class "atc-banner__text-wrapper"}
             [:div
              {:class
               (str "atc-banner__text "
                 (if text-light?
                   "atc-banner__text--light"
                   "atc-banner__text--dark"))}
              [:h3 {:class "atc-banner__title"} (:title banner)]
              (when (:description banner)
                [:p {:class "atc-banner__description"} (:description banner)])
              (when (:buttontext banner)
                [:div {:class "atc-banner__cta"}
                 (buttons/button-web (:buttontext banner)
                   {:type :span-button
                    :style (if text-light? :light :dark)})])]])]

      [:div {:class "u-margin-top-24"}
       (if  (not-empty (:url banner))
         [:a {:href (:url banner)
              :rel "nofollow"
              :class (str "atc-banner " (or color-class ""))}
          banner-content]
         [:div {:class (str "atc-banner " (or color-class ""))}
          banner-content])])))

;; ========= Main Add to Cart Component ===========================

(rum/defc add-to-cart < rum/reactive
  "Main add to cart component that orchestrates all sub-components"
  [app-atom
   {:keys [cart-add-response
           banner
           cart-merch]}]

  ;; Extract data directly from cart-add-response
  (let [{:keys [message items variations totals]} cart-add-response
        first-item (first items)
        special-voucher-message (:special_applied_message message)
        registry-order-id? (cmn/curact app-atom [:registry/order-id])]

    [:div
     (special-voucher-message-display special-voucher-message)

     [:div
      (cond
        registry-order-id?
        (registry-question app-atom cart-add-response)

        :else
        (regular-cart-item app-atom cart-add-response))]

     (cond
       banner
       (banner-component app-atom banner)

       (and cart-merch (not special-voucher-message))
       (recommended-products-section app-atom cart-merch))]))

;; ========= Modal Body Component ===========================

(rum/defc add-to-cart-modal-body < rum/reactive
  "Modal body component for add-to-cart modal"
  [app-atom config-atom _]
  (let [config (rum/react config-atom)
        {:keys [cart-add-response loading?]}  config

        ;; Get suggested products and banner from app state
        {:keys [banner suggested-products]} (cmn/curact app-atom [:add-to-cart])]

    [:div
     (add-to-cart app-atom
       {:cart-add-response cart-add-response
        :banner banner
        :cart-merch suggested-products})]))

;; ========= Modal Configuration ===========================

(defmethod grid/modal-config :cart/add-to-cart-modal [_ _ _]
  {:body add-to-cart-modal-body
   :modal-type :variable
   :cancel-key :cart/close-add-to-cart-modal})

;; ========= Action Handlers ===========================

(defmethod grid/action :cart/close-add-to-cart-modal [app-atom _ _]
  (grid/close-modal app-atom))

